import * as React from "react"

export const MapTicks = () => (
  <svg
    width="877"
    height="511"
    viewBox="0 0 877 511"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M74.5441 0.599365C80.5819 0.599365 85.4452 5.31366 85.4452 11.0904C85.4452 16.8672 80.5819 21.5815 74.5441 21.5815C68.5064 21.5815 63.6431 16.8672 63.6431 11.0904C63.6431 5.31366 68.5064 0.599365 74.5441 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 0.599365C112.154 0.599365 117.018 5.31365 117.018 11.0904C117.018 16.8672 112.154 21.5815 106.117 21.5815C100.079 21.5815 95.2156 16.8672 95.2156 11.0904C95.2156 5.31366 100.079 0.599365 106.117 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 0.599365C143.727 0.599365 148.59 5.31366 148.59 11.0904C148.59 16.8672 143.727 21.5815 137.689 21.5815C131.651 21.5815 126.788 16.8672 126.788 11.0904C126.788 5.31366 131.651 0.599365 137.689 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 0.599365C175.299 0.599365 180.162 5.31366 180.162 11.0904C180.162 16.8672 175.299 21.5815 169.261 21.5815C163.223 21.5815 158.36 16.8672 158.36 11.0904C158.36 5.31366 163.223 0.599365 169.261 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 0.599365C206.87 0.599365 211.733 5.31365 211.733 11.0904C211.733 16.8672 206.87 21.5815 200.832 21.5815C194.794 21.5815 189.931 16.8672 189.931 11.0904C189.931 5.31371 194.796 0.599365 200.832 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 0.599365C491.893 0.599365 496.758 5.3137 496.758 11.0904C496.758 16.8672 491.893 21.5815 485.857 21.5815C479.819 21.5815 474.956 16.8672 474.956 11.0904C474.956 5.31365 479.819 0.599365 485.857 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M865.599 0.599365C871.635 0.599365 876.5 5.3137 876.5 11.0904C876.5 16.8672 871.635 21.5815 865.599 21.5815C859.561 21.5815 854.698 16.8672 854.698 11.0904C854.698 5.3136 859.56 0.599365 865.599 0.599365Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M42.972 31.0364C49.0097 31.0364 53.8731 35.7507 53.8731 41.5275C53.8731 47.3043 49.0097 52.0186 42.972 52.0186C36.9343 52.0186 32.0709 47.3043 32.0709 41.5275C32.0709 35.7507 36.9343 31.0364 42.972 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M74.5441 31.0364C80.5819 31.0364 85.4452 35.7507 85.4452 41.5275C85.4452 47.3043 80.5819 52.0186 74.5441 52.0186C68.5064 52.0186 63.6431 47.3043 63.6431 41.5275C63.6431 35.7507 68.5064 31.0364 74.5441 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 31.0364C112.154 31.0364 117.018 35.7507 117.018 41.5275C117.018 47.3043 112.154 52.0186 106.117 52.0186C100.079 52.0186 95.2156 47.3043 95.2156 41.5275C95.2156 35.7507 100.079 31.0364 106.117 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 31.0364C143.727 31.0364 148.59 35.7507 148.59 41.5275C148.59 47.3043 143.727 52.0186 137.689 52.0186C131.651 52.0186 126.788 47.3043 126.788 41.5275C126.788 35.7507 131.651 31.0364 137.689 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M169.261 31.0364C175.299 31.0364 180.162 35.7507 180.162 41.5275C180.162 47.3043 175.299 52.0186 169.261 52.0186C163.223 52.0186 158.36 47.3043 158.36 41.5275C158.36 35.7507 163.223 31.0364 169.261 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 31.0364C206.87 31.0364 211.733 35.7507 211.733 41.5275C211.733 47.3043 206.87 52.0186 200.832 52.0186C194.794 52.0186 189.931 47.3043 189.931 41.5275C189.931 35.7507 194.796 31.0364 200.832 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 31.0364C238.442 31.0364 243.305 35.7507 243.305 41.5275C243.305 47.3043 238.442 52.0186 232.404 52.0186C226.366 52.0186 221.503 47.3043 221.503 41.5275C221.503 35.7507 226.366 31.0364 232.404 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 31.0364C270.014 31.0364 274.878 35.7507 274.878 41.5275C274.878 47.3043 270.014 52.0186 263.977 52.0186C257.939 52.0186 253.076 47.3043 253.076 41.5275C253.076 35.7507 257.939 31.0364 263.977 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 31.0364C302.465 31.0364 307.328 35.7507 307.328 41.5275C307.328 47.3043 302.465 52.0186 296.427 52.0186C290.389 52.0186 285.526 47.3043 285.526 41.5275C285.526 35.7506 290.387 31.0364 296.427 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M327.997 31.0364C334.035 31.0364 338.898 35.7507 338.898 41.5275C338.898 47.3043 334.035 52.0186 327.997 52.0186C321.959 52.0186 317.096 47.3043 317.096 41.5275C317.096 35.7507 321.959 31.0364 327.997 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 31.0364C365.607 31.0364 370.47 35.7507 370.47 41.5275C370.47 47.3043 365.607 52.0186 359.569 52.0186C353.532 52.0186 348.668 47.3043 348.668 41.5275C348.668 35.7507 353.532 31.0364 359.569 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M391.142 31.0364C397.179 31.0364 402.043 35.7507 402.043 41.5275C402.043 47.3043 397.179 52.0186 391.142 52.0186C385.104 52.0186 380.24 47.3043 380.24 41.5275C380.24 35.7507 385.104 31.0364 391.142 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 31.0364C428.752 31.0364 433.615 35.7507 433.615 41.5275C433.615 47.3043 428.752 52.0186 422.714 52.0186C416.676 52.0186 411.813 47.3043 411.813 41.5275C411.813 35.7507 416.676 31.0364 422.714 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 31.0364C460.322 31.0364 465.186 35.7507 465.186 41.5275C465.186 47.3043 460.322 52.0186 454.285 52.0186C448.247 52.0186 443.384 47.3043 443.384 41.5275C443.384 35.7507 448.247 31.0364 454.285 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M485.857 31.0364C491.893 31.0364 496.758 35.7507 496.758 41.5275C496.758 47.3043 491.893 52.0186 485.857 52.0186C479.819 52.0186 474.956 47.3043 474.956 41.5275C474.956 35.7507 479.819 31.0364 485.857 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M517.429 31.0364C523.465 31.0364 528.33 35.7507 528.33 41.5275C528.33 47.3043 523.465 52.0186 517.429 52.0186C511.391 52.0186 506.528 47.3043 506.528 41.5275C506.528 35.7507 511.391 31.0364 517.429 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 31.0364C555.038 31.0364 559.903 35.7507 559.903 41.5275C559.903 47.3043 555.038 52.0186 549.002 52.0186C542.964 52.0186 538.101 47.3043 538.101 41.5275C538.101 35.7507 542.964 31.0364 549.002 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M834.026 31.0364C840.062 31.0364 844.927 35.7507 844.927 41.5275C844.927 47.3043 840.062 52.0186 834.026 52.0186C827.989 52.0186 823.125 47.3043 823.125 41.5275C823.125 35.7506 827.987 31.0364 834.026 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M865.599 31.0364C871.635 31.0364 876.5 35.7507 876.5 41.5275C876.5 47.3043 871.635 52.0186 865.599 52.0186C859.561 52.0186 854.698 47.3043 854.698 41.5275C854.698 35.7506 859.56 31.0364 865.599 31.0364Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M42.972 61.4729C49.0097 61.4729 53.8731 66.1872 53.8731 71.964C53.8731 77.7408 49.0097 82.4552 42.972 82.4552C36.9343 82.4552 32.0709 77.7408 32.0709 71.964C32.0709 66.1872 36.9343 61.4729 42.972 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 61.4729C80.5819 61.4729 85.4452 66.1872 85.4452 71.964C85.4452 77.7408 80.5819 82.4552 74.5441 82.4552C68.5064 82.4552 63.6431 77.7408 63.6431 71.964C63.6431 66.1872 68.5064 61.4729 74.5441 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 61.4729C112.154 61.4729 117.018 66.1872 117.018 71.964C117.018 77.7408 112.154 82.4552 106.117 82.4552C100.079 82.4552 95.2156 77.7408 95.2156 71.964C95.2156 66.1872 100.079 61.4729 106.117 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 61.4729C143.727 61.4729 148.59 66.1872 148.59 71.964C148.59 77.7408 143.727 82.4552 137.689 82.4552C131.651 82.4552 126.788 77.7408 126.788 71.964C126.788 66.1872 131.651 61.4729 137.689 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 61.4729C175.299 61.4729 180.162 66.1872 180.162 71.964C180.162 77.7408 175.299 82.4552 169.261 82.4552C163.223 82.4552 158.36 77.7408 158.36 71.964C158.36 66.1872 163.223 61.4729 169.261 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 61.4729C238.442 61.4729 243.305 66.1872 243.305 71.964C243.305 77.7408 238.442 82.4552 232.404 82.4552C226.366 82.4552 221.503 77.7408 221.503 71.964C221.503 66.1872 226.366 61.4729 232.404 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 61.4729C270.014 61.4729 274.878 66.1872 274.878 71.964C274.878 77.7408 270.014 82.4552 263.977 82.4552C257.939 82.4552 253.076 77.7408 253.076 71.964C253.076 66.1872 257.939 61.4729 263.977 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 61.4729C302.465 61.4729 307.328 66.1872 307.328 71.964C307.328 77.7408 302.465 82.4552 296.427 82.4552C290.389 82.4552 285.526 77.7408 285.526 71.964C285.526 66.1872 290.387 61.4729 296.427 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 61.4729C334.035 61.4729 338.898 66.1872 338.898 71.964C338.898 77.7408 334.035 82.4552 327.997 82.4552C321.959 82.4552 317.096 77.7408 317.096 71.964C317.096 66.1872 321.959 61.4729 327.997 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 61.4729C365.607 61.4729 370.47 66.1872 370.47 71.964C370.47 77.7408 365.607 82.4552 359.569 82.4552C353.532 82.4552 348.668 77.7408 348.668 71.964C348.668 66.1872 353.532 61.4729 359.569 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 61.4729C397.179 61.4729 402.043 66.1872 402.043 71.964C402.043 77.7408 397.179 82.4552 391.142 82.4552C385.104 82.4552 380.24 77.7408 380.24 71.964C380.24 66.1872 385.104 61.4729 391.142 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 61.4729C428.752 61.4729 433.615 66.1872 433.615 71.964C433.615 77.7408 428.752 82.4552 422.714 82.4552C416.676 82.4552 411.813 77.7408 411.813 71.964C411.813 66.1872 416.676 61.4729 422.714 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M454.285 61.4729C460.322 61.4729 465.186 66.1872 465.186 71.964C465.186 77.7408 460.322 82.4552 454.285 82.4552C448.247 82.4552 443.384 77.7408 443.384 71.964C443.384 66.1872 448.247 61.4729 454.285 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M485.857 61.4729C491.893 61.4729 496.758 66.1873 496.758 71.964C496.758 77.7408 491.893 82.4552 485.857 82.4552C479.819 82.4552 474.956 77.7408 474.956 71.964C474.956 66.1872 479.819 61.4729 485.857 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M549.002 61.4729C555.038 61.4729 559.903 66.1873 559.903 71.964C559.903 77.7408 555.038 82.4552 549.002 82.4552C542.964 82.4552 538.101 77.7408 538.101 71.964C538.101 66.1872 542.964 61.4729 549.002 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M580.574 61.4729C586.61 61.4729 591.475 66.1873 591.475 71.964C591.475 77.7408 586.61 82.4552 580.574 82.4552C574.536 82.4552 569.673 77.7408 569.673 71.964C569.673 66.1872 574.534 61.4729 580.574 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 61.4729C619.06 61.4729 623.923 66.1872 623.923 71.964C623.923 77.7408 619.06 82.4552 613.022 82.4552C606.986 82.4552 602.121 77.7408 602.121 71.964C602.121 66.1872 606.984 61.4729 613.022 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 61.4729C776.92 61.4729 781.784 66.1872 781.784 71.964C781.784 77.7408 776.92 82.4552 770.882 82.4552C764.845 82.4552 759.981 77.7408 759.981 71.964C759.981 66.1872 764.845 61.4729 770.882 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M802.455 61.4729C808.491 61.4729 813.356 66.1873 813.356 71.964C813.356 77.7408 808.491 82.4552 802.455 82.4552C796.417 82.4552 791.554 77.7409 791.554 71.964C791.554 66.1872 796.417 61.4729 802.455 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M834.026 61.4729C840.062 61.4729 844.927 66.1873 844.927 71.964C844.927 77.7408 840.062 82.4552 834.026 82.4552C827.989 82.4552 823.125 77.7409 823.125 71.964C823.125 66.1872 827.987 61.4729 834.026 61.4729Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M42.972 92.7549C49.0097 92.7549 53.8731 97.4692 53.8731 103.246C53.8731 109.023 49.0097 113.737 42.972 113.737C36.9343 113.737 32.0709 109.023 32.0709 103.246C32.0709 97.4692 36.9343 92.7549 42.972 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 92.7549C80.5819 92.7549 85.4452 97.4692 85.4452 103.246C85.4452 109.023 80.5819 113.737 74.5441 113.737C68.5064 113.737 63.6431 109.023 63.6431 103.246C63.6431 97.4692 68.5064 92.7549 74.5441 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 92.7549C112.154 92.7549 117.018 97.4692 117.018 103.246C117.018 109.023 112.154 113.737 106.117 113.737C100.079 113.737 95.2156 109.023 95.2156 103.246C95.2156 97.4692 100.079 92.7549 106.117 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 92.7549C143.727 92.7549 148.59 97.4692 148.59 103.246C148.59 109.023 143.727 113.737 137.689 113.737C131.651 113.737 126.788 109.023 126.788 103.246C126.788 97.4692 131.651 92.7549 137.689 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 92.7549C175.299 92.7549 180.162 97.4692 180.162 103.246C180.162 109.023 175.299 113.737 169.261 113.737C163.223 113.737 158.36 109.023 158.36 103.246C158.36 97.4692 163.223 92.7549 169.261 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 92.7549C206.87 92.7549 211.733 97.4692 211.733 103.246C211.733 109.023 206.87 113.737 200.832 113.737C194.794 113.737 189.931 109.023 189.931 103.246C189.931 97.4692 194.796 92.7549 200.832 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M232.404 92.7549C238.442 92.7549 243.305 97.4692 243.305 103.246C243.305 109.023 238.442 113.737 232.404 113.737C226.366 113.737 221.503 109.023 221.503 103.246C221.503 97.4692 226.366 92.7549 232.404 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 92.7549C270.014 92.7549 274.878 97.4692 274.878 103.246C274.878 109.023 270.014 113.737 263.977 113.737C257.939 113.737 253.076 109.023 253.076 103.246C253.076 97.4692 257.939 92.7549 263.977 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 92.7549C302.465 92.7549 307.328 97.4692 307.328 103.246C307.328 109.023 302.465 113.737 296.427 113.737C290.389 113.737 285.526 109.023 285.526 103.246C285.526 97.4691 290.387 92.7549 296.427 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 92.7549C334.035 92.7549 338.898 97.4692 338.898 103.246C338.898 109.023 334.035 113.737 327.997 113.737C321.959 113.737 317.096 109.023 317.096 103.246C317.096 97.4692 321.959 92.7549 327.997 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M359.569 92.7549C365.607 92.7549 370.47 97.4692 370.47 103.246C370.47 109.023 365.607 113.737 359.569 113.737C353.532 113.737 348.668 109.023 348.668 103.246C348.668 97.4692 353.532 92.7549 359.569 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 92.7549C397.179 92.7549 402.043 97.4692 402.043 103.246C402.043 109.023 397.179 113.737 391.142 113.737C385.104 113.737 380.24 109.023 380.24 103.246C380.24 97.4692 385.104 92.7549 391.142 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 92.7549C428.752 92.7549 433.615 97.4692 433.615 103.246C433.615 109.023 428.752 113.737 422.714 113.737C416.676 113.737 411.813 109.023 411.813 103.246C411.813 97.4692 416.676 92.7549 422.714 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M454.285 92.7549C460.322 92.7549 465.186 97.4692 465.186 103.246C465.186 109.023 460.322 113.737 454.285 113.737C448.247 113.737 443.384 109.023 443.384 103.246C443.384 97.4692 448.247 92.7549 454.285 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M485.857 92.7549C491.893 92.7549 496.758 97.4692 496.758 103.246C496.758 109.023 491.893 113.737 485.857 113.737C479.819 113.737 474.956 109.023 474.956 103.246C474.956 97.4692 479.819 92.7549 485.857 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M517.429 92.7549C523.465 92.7549 528.33 97.4692 528.33 103.246C528.33 109.023 523.465 113.737 517.429 113.737C511.391 113.737 506.528 109.023 506.528 103.246C506.528 97.4692 511.391 92.7549 517.429 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M549.002 92.7549C555.038 92.7549 559.903 97.4692 559.903 103.246C559.903 109.023 555.038 113.737 549.002 113.737C542.964 113.737 538.101 109.023 538.101 103.246C538.101 97.4692 542.964 92.7549 549.002 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M580.574 92.7549C586.61 92.7549 591.475 97.4692 591.475 103.246C591.475 109.023 586.61 113.737 580.574 113.737C574.536 113.737 569.673 109.023 569.673 103.246C569.673 97.4691 574.534 92.7549 580.574 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 92.7549C650.632 92.7549 655.495 97.4692 655.495 103.246C655.495 109.023 650.632 113.737 644.594 113.737C638.558 113.737 633.693 109.023 633.693 103.246C633.693 97.4692 638.557 92.7549 644.594 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 92.7549C776.92 92.7549 781.784 97.4692 781.784 103.246C781.784 109.023 776.92 113.737 770.882 113.737C764.845 113.737 759.981 109.023 759.981 103.246C759.981 97.4692 764.845 92.7549 770.882 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M802.455 92.7549C808.491 92.7549 813.356 97.4692 813.356 103.246C813.356 109.023 808.491 113.737 802.455 113.737C796.417 113.737 791.554 109.023 791.554 103.246C791.554 97.4692 796.417 92.7549 802.455 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M834.026 92.7549C840.062 92.7549 844.927 97.4692 844.927 103.246C844.927 109.023 840.062 113.737 834.026 113.737C827.989 113.737 823.125 109.023 823.125 103.246C823.125 97.4691 827.987 92.7549 834.026 92.7549Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M11.4011 123.191C17.4388 123.191 22.3022 127.905 22.3022 133.682C22.3022 139.459 17.4388 144.173 11.4011 144.173C5.36335 144.173 0.5 139.459 0.5 133.682C0.5 127.905 5.36163 123.191 11.4011 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M42.972 123.191C49.0097 123.191 53.8731 127.905 53.8731 133.682C53.8731 139.459 49.0097 144.173 42.972 144.173C36.9343 144.173 32.0709 139.459 32.0709 133.682C32.0709 127.905 36.9343 123.191 42.972 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 123.191C80.5819 123.191 85.4452 127.905 85.4452 133.682C85.4452 139.459 80.5819 144.173 74.5441 144.173C68.5064 144.173 63.6431 139.459 63.6431 133.682C63.6431 127.905 68.5064 123.191 74.5441 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 123.191C112.154 123.191 117.018 127.905 117.018 133.682C117.018 139.459 112.154 144.173 106.117 144.173C100.079 144.173 95.2156 139.459 95.2156 133.682C95.2156 127.905 100.079 123.191 106.117 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M137.689 123.191C143.727 123.191 148.59 127.905 148.59 133.682C148.59 139.459 143.727 144.173 137.689 144.173C131.651 144.173 126.788 139.459 126.788 133.682C126.788 127.905 131.651 123.191 137.689 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 123.191C175.299 123.191 180.162 127.905 180.162 133.682C180.162 139.459 175.299 144.173 169.261 144.173C163.223 144.173 158.36 139.459 158.36 133.682C158.36 127.905 163.223 123.191 169.261 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 123.191C206.87 123.191 211.733 127.905 211.733 133.682C211.733 139.459 206.87 144.173 200.832 144.173C194.794 144.173 189.931 139.459 189.931 133.682C189.931 127.906 194.796 123.191 200.832 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 123.191C238.442 123.191 243.305 127.905 243.305 133.682C243.305 139.459 238.442 144.173 232.404 144.173C226.366 144.173 221.503 139.459 221.503 133.682C221.503 127.905 226.366 123.191 232.404 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 123.191C270.014 123.191 274.878 127.905 274.878 133.682C274.878 139.459 270.014 144.173 263.977 144.173C257.939 144.173 253.076 139.459 253.076 133.682C253.076 127.905 257.939 123.191 263.977 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 123.191C302.465 123.191 307.328 127.905 307.328 133.682C307.328 139.459 302.465 144.173 296.427 144.173C290.389 144.173 285.526 139.459 285.526 133.682C285.526 127.905 290.387 123.191 296.427 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 123.191C334.035 123.191 338.898 127.905 338.898 133.682C338.898 139.459 334.035 144.173 327.997 144.173C321.959 144.173 317.096 139.459 317.096 133.682C317.096 127.905 321.959 123.191 327.997 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 123.191C365.607 123.191 370.47 127.905 370.47 133.682C370.47 139.459 365.607 144.173 359.569 144.173C353.532 144.173 348.668 139.459 348.668 133.682C348.668 127.905 353.532 123.191 359.569 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 123.191C397.179 123.191 402.043 127.905 402.043 133.682C402.043 139.459 397.179 144.173 391.142 144.173C385.104 144.173 380.24 139.459 380.24 133.682C380.24 127.905 385.104 123.191 391.142 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 123.191C428.752 123.191 433.615 127.905 433.615 133.682C433.615 139.459 428.752 144.173 422.714 144.173C416.676 144.173 411.813 139.459 411.813 133.682C411.813 127.905 416.676 123.191 422.714 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M454.285 123.191C460.322 123.191 465.186 127.905 465.186 133.682C465.186 139.459 460.322 144.173 454.285 144.173C448.247 144.173 443.384 139.459 443.384 133.682C443.384 127.905 448.247 123.191 454.285 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M485.857 123.191C491.893 123.191 496.758 127.906 496.758 133.682C496.758 139.459 491.893 144.173 485.857 144.173C479.819 144.173 474.956 139.459 474.956 133.682C474.956 127.905 479.819 123.191 485.857 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M517.429 123.191C523.465 123.191 528.33 127.906 528.33 133.682C528.33 139.459 523.465 144.173 517.429 144.173C511.391 144.173 506.528 139.459 506.528 133.682C506.528 127.905 511.391 123.191 517.429 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M549.002 123.191C555.038 123.191 559.903 127.906 559.903 133.682C559.903 139.459 555.038 144.173 549.002 144.173C542.964 144.173 538.101 139.459 538.101 133.682C538.101 127.905 542.964 123.191 549.002 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M580.574 123.191C586.61 123.191 591.475 127.906 591.475 133.682C591.475 139.459 586.61 144.173 580.574 144.173C574.536 144.173 569.673 139.459 569.673 133.682C569.673 127.905 574.534 123.191 580.574 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M613.022 123.191C619.06 123.191 623.923 127.905 623.923 133.682C623.923 139.459 619.06 144.173 613.022 144.173C606.986 144.173 602.121 139.459 602.121 133.682C602.121 127.905 606.984 123.191 613.022 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M644.594 123.191C650.632 123.191 655.495 127.905 655.495 133.682C655.495 139.459 650.632 144.173 644.594 144.173C638.558 144.173 633.693 139.459 633.693 133.682C633.693 127.905 638.557 123.191 644.594 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M676.167 123.191C682.204 123.191 687.068 127.905 687.068 133.682C687.068 139.459 682.204 144.173 676.167 144.173C670.129 144.173 665.266 139.459 665.266 133.682C665.266 127.905 670.127 123.191 676.167 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M739.31 123.191C745.348 123.191 750.211 127.905 750.211 133.682C750.211 139.459 745.348 144.173 739.31 144.173C733.272 144.173 728.409 139.459 728.409 133.682C728.409 127.905 733.272 123.191 739.31 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M770.882 123.191C776.92 123.191 781.784 127.905 781.784 133.682C781.784 139.459 776.92 144.173 770.882 144.173C764.845 144.173 759.981 139.459 759.981 133.682C759.981 127.905 764.845 123.191 770.882 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M802.455 123.191C808.491 123.191 813.356 127.906 813.356 133.682C813.356 139.459 808.491 144.173 802.455 144.173C796.417 144.173 791.554 139.459 791.554 133.682C791.554 127.905 796.417 123.191 802.455 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M834.026 123.191C840.062 123.191 844.927 127.906 844.927 133.682C844.927 139.459 840.062 144.173 834.026 144.173C827.989 144.173 823.125 139.459 823.125 133.682C823.125 127.905 827.987 123.191 834.026 123.191Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M11.4011 153.629C17.4388 153.629 22.3022 158.343 22.3022 164.12C22.3022 169.896 17.4388 174.611 11.4011 174.611C5.36334 174.611 0.5 169.896 0.5 164.12C0.5 158.343 5.36163 153.629 11.4011 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M53.8731 164.12C53.8731 158.343 49.0097 153.629 42.972 153.629C36.9344 153.629 32.0727 158.343 32.0709 164.12H53.8731ZM53.8731 164.12C53.8731 169.896 49.0097 174.611 42.972 174.611M53.8731 164.12L42.972 174.611M42.972 174.611C36.9343 174.611 32.071 169.897 32.0709 164.12L42.972 174.611Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 153.629C80.5819 153.629 85.4452 158.343 85.4452 164.12C85.4452 169.896 80.5819 174.611 74.5441 174.611C68.5064 174.611 63.6431 169.896 63.6431 164.12C63.6431 158.343 68.5064 153.629 74.5441 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 153.629C112.154 153.629 117.018 158.343 117.018 164.12C117.018 169.896 112.154 174.611 106.117 174.611C100.079 174.611 95.2156 169.896 95.2156 164.12C95.2156 158.343 100.079 153.629 106.117 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 153.629C143.727 153.629 148.59 158.343 148.59 164.12C148.59 169.896 143.727 174.611 137.689 174.611C131.651 174.611 126.788 169.896 126.788 164.12C126.788 158.343 131.651 153.629 137.689 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 153.629C175.299 153.629 180.162 158.343 180.162 164.12C180.162 169.896 175.299 174.611 169.261 174.611C163.223 174.611 158.36 169.896 158.36 164.12C158.36 158.343 163.223 153.629 169.261 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 153.629C206.87 153.629 211.733 158.343 211.733 164.12C211.733 169.896 206.87 174.611 200.832 174.611C194.794 174.611 189.931 169.896 189.931 164.12C189.931 158.343 194.796 153.629 200.832 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 153.629C238.442 153.629 243.305 158.343 243.305 164.12C243.305 169.896 238.442 174.611 232.404 174.611C226.366 174.611 221.503 169.896 221.503 164.12C221.503 158.343 226.366 153.629 232.404 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 153.629C270.014 153.629 274.878 158.343 274.878 164.12C274.878 169.896 270.014 174.611 263.977 174.611C257.939 174.611 253.076 169.896 253.076 164.12C253.076 158.343 257.939 153.629 263.977 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 153.629C302.465 153.629 307.328 158.343 307.328 164.12C307.328 169.896 302.465 174.611 296.427 174.611C290.389 174.611 285.526 169.896 285.526 164.12C285.526 158.343 290.387 153.629 296.427 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 153.629C334.035 153.629 338.898 158.343 338.898 164.12C338.898 169.896 334.035 174.611 327.997 174.611C321.959 174.611 317.096 169.896 317.096 164.12C317.096 158.343 321.959 153.629 327.997 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 153.629C365.607 153.629 370.47 158.343 370.47 164.12C370.47 169.896 365.607 174.611 359.569 174.611C353.532 174.611 348.668 169.896 348.668 164.12C348.668 158.343 353.532 153.629 359.569 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 153.629C397.179 153.629 402.043 158.343 402.043 164.12C402.043 169.896 397.179 174.611 391.142 174.611C385.104 174.611 380.24 169.896 380.24 164.12C380.24 158.343 385.104 153.629 391.142 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M422.714 153.629C428.752 153.629 433.615 158.343 433.615 164.12C433.615 169.896 428.752 174.611 422.714 174.611C416.676 174.611 411.813 169.896 411.813 164.12C411.813 158.343 416.676 153.629 422.714 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 153.629C460.322 153.629 465.186 158.343 465.186 164.12C465.186 169.896 460.322 174.611 454.285 174.611C448.247 174.611 443.384 169.896 443.384 164.12C443.384 158.343 448.247 153.629 454.285 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M485.857 153.629C491.893 153.629 496.758 158.343 496.758 164.12C496.758 169.896 491.893 174.611 485.857 174.611C479.819 174.611 474.956 169.896 474.956 164.12C474.956 158.343 479.819 153.629 485.857 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M517.429 153.629C523.465 153.629 528.33 158.343 528.33 164.12C528.33 169.896 523.465 174.611 517.429 174.611C511.391 174.611 506.528 169.896 506.528 164.12C506.528 158.343 511.391 153.629 517.429 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M549.002 153.629C555.038 153.629 559.903 158.343 559.903 164.12C559.903 169.896 555.038 174.611 549.002 174.611C542.964 174.611 538.101 169.896 538.101 164.12C538.101 158.343 542.964 153.629 549.002 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M580.574 153.629C586.61 153.629 591.475 158.343 591.475 164.12C591.475 169.896 586.61 174.611 580.574 174.611C574.536 174.611 569.673 169.896 569.673 164.12C569.673 158.343 574.534 153.629 580.574 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M613.022 153.629C619.06 153.629 623.923 158.343 623.923 164.12C623.923 169.896 619.06 174.611 613.022 174.611C606.986 174.611 602.121 169.896 602.121 164.12C602.121 158.343 606.984 153.629 613.022 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M644.594 153.629C650.632 153.629 655.495 158.343 655.495 164.12C655.495 169.896 650.632 174.611 644.594 174.611C638.558 174.611 633.693 169.896 633.693 164.12C633.693 158.343 638.557 153.629 644.594 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M676.167 153.629C682.204 153.629 687.068 158.343 687.068 164.12C687.068 169.896 682.204 174.611 676.167 174.611C670.129 174.611 665.266 169.896 665.266 164.12C665.266 158.343 670.127 153.629 676.167 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M707.737 153.629C713.775 153.629 718.638 158.343 718.638 164.12C718.638 169.896 713.775 174.611 707.737 174.611C701.7 174.611 696.836 169.896 696.836 164.12C696.836 158.343 701.7 153.629 707.737 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M739.157 153.585C745.195 153.585 750.058 158.299 750.058 164.076C750.058 169.853 745.195 174.567 739.157 174.567C733.119 174.567 728.256 169.853 728.256 164.076C728.256 158.299 733.119 153.585 739.157 153.585Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.4"
      d="M770.882 153.629C776.92 153.629 781.784 158.343 781.784 164.12C781.784 169.896 776.92 174.611 770.882 174.611C764.845 174.611 759.981 169.896 759.981 164.12C759.981 158.343 764.845 153.629 770.882 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M802.455 153.629C808.491 153.629 813.356 158.343 813.356 164.12C813.356 169.896 808.491 174.611 802.455 174.611C796.417 174.611 791.554 169.896 791.554 164.12C791.554 158.343 796.417 153.629 802.455 153.629Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M11.4011 184.064C17.4388 184.064 22.3022 188.778 22.3022 194.555C22.3022 200.332 17.4388 205.046 11.4011 205.046C5.36334 205.046 0.5 200.332 0.5 194.555C0.5 188.778 5.36163 184.064 11.4011 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M42.972 184.064C49.0097 184.064 53.8731 188.778 53.8731 194.555C53.8731 200.332 49.0097 205.046 42.972 205.046C36.9343 205.046 32.0709 200.332 32.0709 194.555C32.0709 188.778 36.9343 184.064 42.972 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 184.064C80.5819 184.064 85.4452 188.778 85.4452 194.555C85.4452 200.332 80.5819 205.046 74.5441 205.046C68.5064 205.046 63.6431 200.332 63.6431 194.555C63.6431 188.778 68.5064 184.064 74.5441 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 184.064C143.727 184.064 148.59 188.778 148.59 194.555C148.59 200.332 143.727 205.046 137.689 205.046C131.651 205.046 126.788 200.332 126.788 194.555C126.788 188.778 131.651 184.064 137.689 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 184.064C175.299 184.064 180.162 188.778 180.162 194.555C180.162 200.332 175.299 205.046 169.261 205.046C163.223 205.046 158.36 200.332 158.36 194.555C158.36 188.778 163.223 184.064 169.261 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 184.064C206.87 184.064 211.733 188.778 211.733 194.555C211.733 200.332 206.87 205.046 200.832 205.046C194.794 205.046 189.931 200.332 189.931 194.555C189.931 188.778 194.796 184.064 200.832 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 184.064C238.442 184.064 243.305 188.778 243.305 194.555C243.305 200.332 238.442 205.046 232.404 205.046C226.366 205.046 221.503 200.332 221.503 194.555C221.503 188.778 226.366 184.064 232.404 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 184.064C270.014 184.064 274.878 188.778 274.878 194.555C274.878 200.332 270.014 205.046 263.977 205.046C257.939 205.046 253.076 200.332 253.076 194.555C253.076 188.778 257.939 184.064 263.977 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 184.064C302.465 184.064 307.328 188.778 307.328 194.555C307.328 200.332 302.465 205.046 296.427 205.046C290.389 205.046 285.526 200.332 285.526 194.555C285.526 188.778 290.387 184.064 296.427 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 184.064C334.035 184.064 338.898 188.778 338.898 194.555C338.898 200.332 334.035 205.046 327.997 205.046C321.959 205.046 317.096 200.332 317.096 194.555C317.096 188.778 321.959 184.064 327.997 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 184.064C365.607 184.064 370.47 188.778 370.47 194.555C370.47 200.332 365.607 205.046 359.569 205.046C353.532 205.046 348.668 200.332 348.668 194.555C348.668 188.778 353.532 184.064 359.569 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 184.064C397.179 184.064 402.043 188.778 402.043 194.555C402.043 200.332 397.179 205.046 391.142 205.046C385.104 205.046 380.24 200.332 380.24 194.555C380.24 188.778 385.104 184.064 391.142 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 184.064C428.752 184.064 433.615 188.778 433.615 194.555C433.615 200.332 428.752 205.046 422.714 205.046C416.676 205.046 411.813 200.332 411.813 194.555C411.813 188.778 416.676 184.064 422.714 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 184.064C460.322 184.064 465.186 188.778 465.186 194.555C465.186 200.332 460.322 205.046 454.285 205.046C448.247 205.046 443.384 200.332 443.384 194.555C443.384 188.778 448.247 184.064 454.285 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 184.064C491.893 184.064 496.758 188.778 496.758 194.555C496.758 200.332 491.893 205.046 485.857 205.046C479.819 205.046 474.956 200.332 474.956 194.555C474.956 188.778 479.819 184.064 485.857 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M517.429 184.064C523.465 184.064 528.33 188.778 528.33 194.555C528.33 200.332 523.465 205.046 517.429 205.046C511.391 205.046 506.528 200.332 506.528 194.555C506.528 188.778 511.391 184.064 517.429 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M549.002 184.064C555.038 184.064 559.903 188.778 559.903 194.555C559.903 200.332 555.038 205.046 549.002 205.046C542.964 205.046 538.101 200.332 538.101 194.555C538.101 188.778 542.964 184.064 549.002 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M580.574 184.064C586.61 184.064 591.475 188.778 591.475 194.555C591.475 200.332 586.61 205.046 580.574 205.046C574.536 205.046 569.673 200.332 569.673 194.555C569.673 188.778 574.534 184.064 580.574 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.4"
      d="M613.022 184.064C619.06 184.064 623.923 188.778 623.923 194.555C623.923 200.332 619.06 205.046 613.022 205.046C606.986 205.046 602.121 200.332 602.121 194.555C602.121 188.778 606.984 184.064 613.022 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 184.064C650.632 184.064 655.495 188.778 655.495 194.555C655.495 200.332 650.632 205.046 644.594 205.046C638.558 205.046 633.693 200.332 633.693 194.555C633.693 188.778 638.557 184.064 644.594 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M676.167 184.064C682.204 184.064 687.068 188.778 687.068 194.555C687.068 200.332 682.204 205.046 676.167 205.046C670.129 205.046 665.266 200.332 665.266 194.555C665.266 188.778 670.127 184.064 676.167 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M707.737 184.064C713.775 184.064 718.638 188.778 718.638 194.555C718.638 200.332 713.775 205.046 707.737 205.046C701.7 205.046 696.836 200.332 696.836 194.555C696.836 188.778 701.7 184.064 707.737 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.4"
      d="M739.31 184.064C745.348 184.064 750.211 188.778 750.211 194.555C750.211 200.332 745.348 205.046 739.31 205.046C733.272 205.046 728.409 200.332 728.409 194.555C728.409 188.778 733.272 184.064 739.31 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.4"
      d="M802.455 184.064C808.491 184.064 813.356 188.778 813.356 194.555C813.356 200.332 808.491 205.046 802.455 205.046C796.417 205.046 791.554 200.332 791.554 194.555C791.554 188.778 796.417 184.064 802.455 184.064Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M53.8731 224.992C53.8731 219.215 49.0097 214.501 42.972 214.501C36.9344 214.501 32.0727 219.215 32.0709 224.992H53.8731ZM53.8731 224.992C53.8731 230.769 49.0097 235.483 42.972 235.483M53.8731 224.992L42.972 235.483M42.972 235.483C36.9343 235.483 32.071 230.769 32.0709 224.992L42.972 235.483Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 214.501C80.5819 214.501 85.4452 219.215 85.4452 224.992C85.4452 230.769 80.5819 235.483 74.5441 235.483C68.5064 235.483 63.6431 230.769 63.6431 224.992C63.6431 219.215 68.5064 214.501 74.5441 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M106.117 214.501C112.154 214.501 117.018 219.215 117.018 224.992C117.018 230.769 112.154 235.483 106.117 235.483C100.079 235.483 95.2156 230.769 95.2156 224.992C95.2156 219.215 100.079 214.501 106.117 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 214.501C143.727 214.501 148.59 219.215 148.59 224.992C148.59 230.769 143.727 235.483 137.689 235.483C131.651 235.483 126.788 230.769 126.788 224.992C126.788 219.215 131.651 214.501 137.689 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 214.501C175.299 214.501 180.162 219.215 180.162 224.992C180.162 230.769 175.299 235.483 169.261 235.483C163.223 235.483 158.36 230.769 158.36 224.992C158.36 219.215 163.223 214.501 169.261 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 214.501C206.87 214.501 211.733 219.215 211.733 224.992C211.733 230.769 206.87 235.483 200.832 235.483C194.794 235.483 189.931 230.769 189.931 224.992C189.931 219.215 194.796 214.501 200.832 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 214.501C238.442 214.501 243.305 219.215 243.305 224.992C243.305 230.769 238.442 235.483 232.404 235.483C226.366 235.483 221.503 230.769 221.503 224.992C221.503 219.215 226.366 214.501 232.404 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M263.977 214.501C270.014 214.501 274.878 219.215 274.878 224.992C274.878 230.769 270.014 235.483 263.977 235.483C257.939 235.483 253.076 230.769 253.076 224.992C253.076 219.215 257.939 214.501 263.977 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 214.501C302.465 214.501 307.328 219.215 307.328 224.992C307.328 230.769 302.465 235.483 296.427 235.483C290.389 235.483 285.526 230.769 285.526 224.992C285.526 219.215 290.387 214.501 296.427 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 214.501C334.035 214.501 338.898 219.215 338.898 224.992C338.898 230.769 334.035 235.483 327.997 235.483C321.959 235.483 317.096 230.769 317.096 224.992C317.096 219.215 321.959 214.501 327.997 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 214.501C365.607 214.501 370.47 219.215 370.47 224.992C370.47 230.769 365.607 235.483 359.569 235.483C353.532 235.483 348.668 230.769 348.668 224.992C348.668 219.215 353.532 214.501 359.569 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 214.501C397.179 214.501 402.043 219.215 402.043 224.992C402.043 230.769 397.179 235.483 391.142 235.483C385.104 235.483 380.24 230.769 380.24 224.992C380.24 219.215 385.104 214.501 391.142 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M422.714 214.501C428.752 214.501 433.615 219.215 433.615 224.992C433.615 230.769 428.752 235.483 422.714 235.483C416.676 235.483 411.813 230.769 411.813 224.992C411.813 219.215 416.676 214.501 422.714 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 214.501C460.322 214.501 465.186 219.215 465.186 224.992C465.186 230.769 460.322 235.483 454.285 235.483C448.247 235.483 443.384 230.769 443.384 224.992C443.384 219.215 448.247 214.501 454.285 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 214.501C491.893 214.501 496.758 219.215 496.758 224.992C496.758 230.769 491.893 235.483 485.857 235.483C479.819 235.483 474.956 230.769 474.956 224.992C474.956 219.215 479.819 214.501 485.857 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M517.429 214.501C523.465 214.501 528.33 219.215 528.33 224.992C528.33 230.769 523.465 235.483 517.429 235.483C511.391 235.483 506.528 230.769 506.528 224.992C506.528 219.215 511.391 214.501 517.429 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 214.501C555.038 214.501 559.903 219.215 559.903 224.992C559.903 230.769 555.038 235.483 549.002 235.483C542.964 235.483 538.101 230.769 538.101 224.992C538.101 219.215 542.964 214.501 549.002 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 214.501C586.61 214.501 591.475 219.215 591.475 224.992C591.475 230.769 586.61 235.483 580.574 235.483C574.536 235.483 569.673 230.769 569.673 224.992C569.673 219.215 574.534 214.501 580.574 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 214.501C619.06 214.501 623.923 219.215 623.923 224.992C623.923 230.769 619.06 235.483 613.022 235.483C606.986 235.483 602.121 230.769 602.121 224.992C602.121 219.215 606.984 214.501 613.022 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 214.501C650.632 214.501 655.495 219.215 655.495 224.992C655.495 230.769 650.632 235.483 644.594 235.483C638.558 235.483 633.693 230.769 633.693 224.992C633.693 219.215 638.557 214.501 644.594 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M676.167 214.501C682.204 214.501 687.068 219.215 687.068 224.992C687.068 230.769 682.204 235.483 676.167 235.483C670.129 235.483 665.266 230.769 665.266 224.992C665.266 219.215 670.127 214.501 676.167 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M707.737 214.501C713.775 214.501 718.638 219.215 718.638 224.992C718.638 230.769 713.775 235.483 707.737 235.483C701.7 235.483 696.836 230.769 696.836 224.992C696.836 219.215 701.7 214.501 707.737 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M739.31 214.501C745.348 214.501 750.211 219.215 750.211 224.992C750.211 230.769 745.348 235.483 739.31 235.483C733.272 235.483 728.409 230.769 728.409 224.992C728.409 219.215 733.272 214.501 739.31 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M770.882 214.501C776.92 214.501 781.784 219.215 781.784 224.992C781.784 230.769 776.92 235.483 770.882 235.483C764.845 235.483 759.981 230.769 759.981 224.992C759.981 219.215 764.845 214.501 770.882 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M802.455 214.501C808.491 214.501 813.356 219.215 813.356 224.992C813.356 230.769 808.491 235.483 802.455 235.483C796.417 235.483 791.554 230.769 791.554 224.992C791.554 219.215 796.417 214.501 802.455 214.501Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M53.8731 255.429C53.8731 249.652 49.0097 244.938 42.972 244.938C36.9344 244.938 32.0727 249.652 32.0709 255.429H53.8731ZM53.8731 255.429C53.8731 261.205 49.0097 265.92 42.972 265.92M53.8731 255.429L42.972 265.92M42.972 265.92C36.9343 265.92 32.071 261.205 32.0709 255.429L42.972 265.92Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 244.938C80.5819 244.938 85.4452 249.652 85.4452 255.429C85.4452 261.205 80.5819 265.92 74.5441 265.92C68.5064 265.92 63.6431 261.205 63.6431 255.429C63.6431 249.652 68.5064 244.938 74.5441 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 244.938C112.154 244.938 117.018 249.652 117.018 255.429C117.018 261.205 112.154 265.92 106.117 265.92C100.079 265.92 95.2156 261.205 95.2156 255.429C95.2156 249.652 100.079 244.938 106.117 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 244.938C143.727 244.938 148.59 249.652 148.59 255.429C148.59 261.205 143.727 265.92 137.689 265.92C131.651 265.92 126.788 261.205 126.788 255.429C126.788 249.652 131.651 244.938 137.689 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 244.938C175.299 244.938 180.162 249.652 180.162 255.429C180.162 261.205 175.299 265.92 169.261 265.92C163.223 265.92 158.36 261.205 158.36 255.429C158.36 249.652 163.223 244.938 169.261 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 244.938C206.87 244.938 211.733 249.652 211.733 255.429C211.733 261.205 206.87 265.92 200.832 265.92C194.794 265.92 189.931 261.205 189.931 255.429C189.931 249.652 194.796 244.938 200.832 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 244.938C238.442 244.938 243.305 249.652 243.305 255.429C243.305 261.205 238.442 265.92 232.404 265.92C226.366 265.92 221.503 261.205 221.503 255.429C221.503 249.652 226.366 244.938 232.404 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 244.938C270.014 244.938 274.878 249.652 274.878 255.429C274.878 261.205 270.014 265.92 263.977 265.92C257.939 265.92 253.076 261.205 253.076 255.429C253.076 249.652 257.939 244.938 263.977 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 244.938C302.465 244.938 307.328 249.652 307.328 255.429C307.328 261.205 302.465 265.92 296.427 265.92C290.389 265.92 285.526 261.205 285.526 255.429C285.526 249.652 290.387 244.938 296.427 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 244.938C334.035 244.938 338.898 249.652 338.898 255.429C338.898 261.205 334.035 265.92 327.997 265.92C321.959 265.92 317.096 261.205 317.096 255.429C317.096 249.652 321.959 244.938 327.997 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 244.938C365.607 244.938 370.47 249.652 370.47 255.429C370.47 261.205 365.607 265.92 359.569 265.92C353.532 265.92 348.668 261.205 348.668 255.429C348.668 249.652 353.532 244.938 359.569 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 244.938C397.179 244.938 402.043 249.652 402.043 255.429C402.043 261.205 397.179 265.92 391.142 265.92C385.104 265.92 380.24 261.205 380.24 255.429C380.24 249.652 385.104 244.938 391.142 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 244.938C428.752 244.938 433.615 249.652 433.615 255.429C433.615 261.205 428.752 265.92 422.714 265.92C416.676 265.92 411.813 261.205 411.813 255.429C411.813 249.652 416.676 244.938 422.714 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 244.938C460.322 244.938 465.186 249.652 465.186 255.429C465.186 261.205 460.322 265.92 454.285 265.92C448.247 265.92 443.384 261.205 443.384 255.429C443.384 249.652 448.247 244.938 454.285 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 244.938C491.893 244.938 496.758 249.652 496.758 255.429C496.758 261.205 491.893 265.92 485.857 265.92C479.819 265.92 474.956 261.205 474.956 255.429C474.956 249.652 479.819 244.938 485.857 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M517.429 244.938C523.465 244.938 528.33 249.652 528.33 255.429C528.33 261.205 523.465 265.92 517.429 265.92C511.391 265.92 506.528 261.205 506.528 255.429C506.528 249.652 511.391 244.938 517.429 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M549.002 244.938C555.038 244.938 559.903 249.652 559.903 255.429C559.903 261.205 555.038 265.92 549.002 265.92C542.964 265.92 538.101 261.205 538.101 255.429C538.101 249.652 542.964 244.938 549.002 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 244.938C586.61 244.938 591.475 249.652 591.475 255.429C591.475 261.205 586.61 265.92 580.574 265.92C574.536 265.92 569.673 261.205 569.673 255.429C569.673 249.652 574.534 244.938 580.574 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 244.938C619.06 244.938 623.923 249.652 623.923 255.429C623.923 261.205 619.06 265.92 613.022 265.92C606.986 265.92 602.121 261.205 602.121 255.429C602.121 249.652 606.984 244.938 613.022 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 244.938C650.632 244.938 655.495 249.652 655.495 255.429C655.495 261.205 650.632 265.92 644.594 265.92C638.558 265.92 633.693 261.205 633.693 255.429C633.693 249.652 638.557 244.938 644.594 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M676.167 244.938C682.204 244.938 687.068 249.652 687.068 255.429C687.068 261.205 682.204 265.92 676.167 265.92C670.129 265.92 665.266 261.205 665.266 255.429C665.266 249.652 670.127 244.938 676.167 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M707.737 244.938C713.775 244.938 718.638 249.652 718.638 255.429C718.638 261.205 713.775 265.92 707.737 265.92C701.7 265.92 696.836 261.205 696.836 255.429C696.836 249.652 701.7 244.938 707.737 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M739.31 244.938C745.348 244.938 750.211 249.652 750.211 255.429C750.211 261.205 745.348 265.92 739.31 265.92C733.272 265.92 728.409 261.205 728.409 255.429C728.409 249.652 733.272 244.938 739.31 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 244.938C776.92 244.938 781.784 249.652 781.784 255.429C781.784 261.205 776.92 265.92 770.882 265.92C764.845 265.92 759.981 261.205 759.981 255.429C759.981 249.652 764.845 244.938 770.882 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M802.455 244.938C808.491 244.938 813.356 249.652 813.356 255.429C813.356 261.205 808.491 265.92 802.455 265.92C796.417 265.92 791.554 261.205 791.554 255.429C791.554 249.652 796.417 244.938 802.455 244.938Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 275.375C80.5819 275.375 85.4452 280.089 85.4452 285.866C85.4452 291.642 80.5819 296.357 74.5441 296.357C68.5064 296.357 63.6431 291.642 63.6431 285.866C63.6431 280.089 68.5064 275.375 74.5441 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 275.375C112.154 275.375 117.018 280.089 117.018 285.866C117.018 291.642 112.154 296.357 106.117 296.357C100.079 296.357 95.2156 291.642 95.2156 285.866C95.2156 280.089 100.079 275.375 106.117 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 275.375C143.727 275.375 148.59 280.089 148.59 285.866C148.59 291.642 143.727 296.357 137.689 296.357C131.651 296.357 126.788 291.642 126.788 285.866C126.788 280.089 131.651 275.375 137.689 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M169.261 275.375C175.299 275.375 180.162 280.089 180.162 285.866C180.162 291.642 175.299 296.357 169.261 296.357C163.223 296.357 158.36 291.642 158.36 285.866C158.36 280.089 163.223 275.375 169.261 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 275.375C206.87 275.375 211.733 280.089 211.733 285.866C211.733 291.642 206.87 296.357 200.832 296.357C194.794 296.357 189.931 291.642 189.931 285.866C189.931 280.089 194.796 275.375 200.832 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M232.404 275.375C238.442 275.375 243.305 280.089 243.305 285.866C243.305 291.642 238.442 296.357 232.404 296.357C226.366 296.357 221.503 291.642 221.503 285.866C221.503 280.089 226.366 275.375 232.404 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 275.375C270.014 275.375 274.878 280.089 274.878 285.866C274.878 291.642 270.014 296.357 263.977 296.357C257.939 296.357 253.076 291.642 253.076 285.866C253.076 280.089 257.939 275.375 263.977 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 275.375C302.465 275.375 307.328 280.089 307.328 285.866C307.328 291.642 302.465 296.357 296.427 296.357C290.389 296.357 285.526 291.642 285.526 285.866C285.526 280.089 290.387 275.375 296.427 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 275.375C334.035 275.375 338.898 280.089 338.898 285.866C338.898 291.642 334.035 296.357 327.997 296.357C321.959 296.357 317.096 291.642 317.096 285.866C317.096 280.089 321.959 275.375 327.997 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 275.375C365.607 275.375 370.47 280.089 370.47 285.866C370.47 291.642 365.607 296.357 359.569 296.357C353.532 296.357 348.668 291.642 348.668 285.866C348.668 280.089 353.532 275.375 359.569 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 275.375C397.179 275.375 402.043 280.089 402.043 285.866C402.043 291.642 397.179 296.357 391.142 296.357C385.104 296.357 380.24 291.642 380.24 285.866C380.24 280.089 385.104 275.375 391.142 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 275.375C428.752 275.375 433.615 280.089 433.615 285.866C433.615 291.642 428.752 296.357 422.714 296.357C416.676 296.357 411.813 291.642 411.813 285.866C411.813 280.089 416.676 275.375 422.714 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 275.375C460.322 275.375 465.186 280.089 465.186 285.866C465.186 291.642 460.322 296.357 454.285 296.357C448.247 296.357 443.384 291.642 443.384 285.866C443.384 280.089 448.247 275.375 454.285 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 275.375C491.893 275.375 496.758 280.089 496.758 285.866C496.758 291.642 491.893 296.357 485.857 296.357C479.819 296.357 474.956 291.642 474.956 285.866C474.956 280.089 479.819 275.375 485.857 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M517.429 275.375C523.465 275.375 528.33 280.089 528.33 285.866C528.33 291.642 523.465 296.357 517.429 296.357C511.391 296.357 506.528 291.642 506.528 285.866C506.528 280.089 511.391 275.375 517.429 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 275.375C555.038 275.375 559.903 280.089 559.903 285.866C559.903 291.642 555.038 296.357 549.002 296.357C542.964 296.357 538.101 291.642 538.101 285.866C538.101 280.089 542.964 275.375 549.002 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 275.375C586.61 275.375 591.475 280.089 591.475 285.866C591.475 291.642 586.61 296.357 580.574 296.357C574.536 296.357 569.673 291.642 569.673 285.866C569.673 280.089 574.534 275.375 580.574 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 275.375C619.06 275.375 623.923 280.089 623.923 285.866C623.923 291.642 619.06 296.357 613.022 296.357C606.986 296.357 602.121 291.642 602.121 285.866C602.121 280.089 606.984 275.375 613.022 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M644.594 275.375C650.632 275.375 655.495 280.089 655.495 285.866C655.495 291.642 650.632 296.357 644.594 296.357C638.558 296.357 633.693 291.642 633.693 285.866C633.693 280.089 638.557 275.375 644.594 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.3"
      d="M676.167 275.375C682.204 275.375 687.068 280.089 687.068 285.866C687.068 291.642 682.204 296.357 676.167 296.357C670.129 296.357 665.266 291.642 665.266 285.866C665.266 280.089 670.127 275.375 676.167 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M707.737 275.375C713.775 275.375 718.638 280.089 718.638 285.866C718.638 291.642 713.775 296.357 707.737 296.357C701.7 296.357 696.836 291.642 696.836 285.866C696.836 280.089 701.7 275.375 707.737 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M739.31 275.375C745.348 275.375 750.211 280.089 750.211 285.866C750.211 291.642 745.348 296.357 739.31 296.357C733.272 296.357 728.409 291.642 728.409 285.866C728.409 280.089 733.272 275.375 739.31 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 275.375C776.92 275.375 781.784 280.089 781.784 285.866C781.784 291.642 776.92 296.357 770.882 296.357C764.845 296.357 759.981 291.642 759.981 285.866C759.981 280.089 764.845 275.375 770.882 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M802.455 275.375C808.491 275.375 813.356 280.089 813.356 285.866C813.356 291.642 808.491 296.357 802.455 296.357C796.417 296.357 791.554 291.642 791.554 285.866C791.554 280.089 796.417 275.375 802.455 275.375Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M74.5441 305.812C80.5819 305.812 85.4452 310.526 85.4452 316.303C85.4452 322.078 80.5818 326.794 74.5441 326.794C68.5065 326.794 63.6431 322.078 63.6431 316.303C63.6431 310.524 68.5064 305.812 74.5441 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 305.812C112.154 305.812 117.018 310.526 117.018 316.303C117.018 322.078 112.154 326.794 106.117 326.794C100.079 326.794 95.2156 322.078 95.2156 316.303C95.2156 310.524 100.079 305.812 106.117 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 305.812C143.727 305.812 148.59 310.526 148.59 316.303C148.59 322.078 143.727 326.794 137.689 326.794C131.651 326.794 126.788 322.078 126.788 316.303C126.788 310.524 131.651 305.812 137.689 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 305.812C175.299 305.812 180.162 310.526 180.162 316.303C180.162 322.078 175.299 326.794 169.261 326.794C163.223 326.794 158.36 322.078 158.36 316.303C158.36 310.524 163.223 305.812 169.261 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 305.812C206.87 305.812 211.733 310.526 211.733 316.303C211.733 322.078 206.87 326.794 200.832 326.794C194.794 326.794 189.931 322.078 189.931 316.303C189.931 310.524 194.796 305.812 200.832 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 305.812C238.442 305.812 243.305 310.526 243.305 316.303C243.305 322.078 238.442 326.794 232.404 326.794C226.366 326.794 221.503 322.078 221.503 316.303C221.503 310.524 226.366 305.812 232.404 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 305.812C270.014 305.812 274.878 310.526 274.878 316.303C274.878 322.078 270.014 326.794 263.977 326.794C257.939 326.794 253.076 322.078 253.076 316.303C253.076 310.524 257.939 305.812 263.977 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 305.812C302.465 305.812 307.328 310.526 307.328 316.303C307.328 322.078 302.464 326.794 296.427 326.794C290.389 326.794 285.526 322.078 285.526 316.303C285.526 310.524 290.387 305.812 296.427 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 305.812C334.035 305.812 338.898 310.526 338.898 316.303C338.898 322.078 334.035 326.794 327.997 326.794C321.959 326.794 317.096 322.078 317.096 316.303C317.096 310.524 321.959 305.812 327.997 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M359.569 305.812C365.607 305.812 370.47 310.526 370.47 316.303C370.47 322.078 365.607 326.794 359.569 326.794C353.532 326.794 348.668 322.078 348.668 316.303C348.668 310.524 353.531 305.812 359.569 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 305.812C397.179 305.812 402.043 310.526 402.043 316.303C402.043 322.078 397.179 326.794 391.142 326.794C385.104 326.794 380.24 322.078 380.24 316.303C380.24 310.524 385.104 305.812 391.142 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 305.812C428.752 305.812 433.615 310.526 433.615 316.303C433.615 322.078 428.752 326.794 422.714 326.794C416.676 326.794 411.813 322.078 411.813 316.303C411.813 310.524 416.676 305.812 422.714 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 305.812C460.322 305.812 465.186 310.526 465.186 316.303C465.186 322.078 460.322 326.794 454.285 326.794C448.247 326.794 443.384 322.078 443.384 316.303C443.384 310.524 448.247 305.812 454.285 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 305.812C491.893 305.812 496.758 310.526 496.758 316.303C496.758 322.078 491.893 326.794 485.857 326.794C479.819 326.794 474.956 322.078 474.956 316.303C474.956 310.524 479.819 305.812 485.857 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M517.429 305.812C523.465 305.812 528.33 310.526 528.33 316.303C528.33 322.078 523.465 326.794 517.429 326.794C511.391 326.794 506.528 322.078 506.528 316.303C506.528 310.524 511.391 305.812 517.429 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 305.812C555.038 305.812 559.903 310.526 559.903 316.303C559.903 322.078 555.038 326.794 549.002 326.794C542.964 326.794 538.101 322.078 538.101 316.303C538.101 310.524 542.964 305.812 549.002 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 305.812C586.61 305.812 591.475 310.526 591.475 316.303C591.475 322.078 586.61 326.794 580.574 326.794C574.536 326.794 569.673 322.078 569.673 316.303C569.673 310.524 574.534 305.812 580.574 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 305.812C619.06 305.812 623.923 310.526 623.923 316.303C623.923 322.078 619.06 326.794 613.022 326.794C606.986 326.794 602.121 322.078 602.121 316.303C602.121 310.524 606.984 305.812 613.022 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 305.812C650.632 305.812 655.495 310.526 655.495 316.303C655.495 322.078 650.632 326.794 644.594 326.794C638.558 326.794 633.693 322.078 633.693 316.303C633.693 310.524 638.557 305.812 644.594 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M676.167 305.812C682.204 305.812 687.068 310.526 687.068 316.303C687.068 322.078 682.204 326.794 676.167 326.794C670.129 326.794 665.266 322.078 665.266 316.303C665.266 310.524 670.127 305.812 676.167 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M707.737 305.812C713.775 305.812 718.638 310.526 718.638 316.303C718.638 322.078 713.775 326.794 707.737 326.794C701.7 326.794 696.836 322.078 696.836 316.303C696.836 310.524 701.699 305.812 707.737 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M739.31 305.812C745.348 305.812 750.211 310.526 750.211 316.303C750.211 322.078 745.347 326.794 739.31 326.794C733.272 326.794 728.409 322.078 728.409 316.303C728.409 310.524 733.272 305.812 739.31 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 305.812C776.92 305.812 781.784 310.526 781.784 316.303C781.784 322.078 776.92 326.794 770.882 326.794C764.845 326.794 759.981 322.078 759.981 316.303C759.981 310.524 764.845 305.812 770.882 305.812Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M106.117 336.249C112.154 336.249 117.018 340.963 117.018 346.74C117.018 352.515 112.154 357.231 106.117 357.231C100.079 357.231 95.2156 352.515 95.2156 346.74C95.2156 340.961 100.079 336.249 106.117 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M137.689 336.249C143.727 336.249 148.59 340.963 148.59 346.74C148.59 352.515 143.727 357.231 137.689 357.231C131.651 357.231 126.788 352.515 126.788 346.74C126.788 340.961 131.651 336.249 137.689 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M169.261 336.249C175.299 336.249 180.162 340.963 180.162 346.74C180.162 352.515 175.299 357.231 169.261 357.231C163.223 357.231 158.36 352.515 158.36 346.74C158.36 340.961 163.223 336.249 169.261 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 336.249C206.87 336.249 211.733 340.963 211.733 346.74C211.733 352.515 206.87 357.231 200.832 357.231C194.794 357.231 189.931 352.515 189.931 346.74C189.931 340.961 194.796 336.249 200.832 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 336.249C238.442 336.249 243.305 340.963 243.305 346.74C243.305 352.515 238.442 357.231 232.404 357.231C226.366 357.231 221.503 352.515 221.503 346.74C221.503 340.961 226.366 336.249 232.404 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 336.249C270.014 336.249 274.878 340.963 274.878 346.74C274.878 352.515 270.014 357.231 263.977 357.231C257.939 357.231 253.076 352.515 253.076 346.74C253.076 340.961 257.939 336.249 263.977 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 336.249C302.465 336.249 307.328 340.963 307.328 346.74C307.328 352.515 302.464 357.231 296.427 357.231C290.389 357.231 285.526 352.515 285.526 346.74C285.526 340.961 290.387 336.249 296.427 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 336.249C334.035 336.249 338.898 340.963 338.898 346.74C338.898 352.515 334.035 357.231 327.997 357.231C321.959 357.231 317.096 352.515 317.096 346.74C317.096 340.961 321.959 336.249 327.997 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 336.249C365.607 336.249 370.47 340.963 370.47 346.74C370.47 352.515 365.607 357.231 359.569 357.231C353.532 357.231 348.668 352.515 348.668 346.74C348.668 340.961 353.531 336.249 359.569 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 336.249C397.179 336.249 402.043 340.963 402.043 346.74C402.043 352.515 397.179 357.231 391.142 357.231C385.104 357.231 380.24 352.515 380.24 346.74C380.24 340.961 385.104 336.249 391.142 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 336.249C428.752 336.249 433.615 340.963 433.615 346.74C433.615 352.515 428.752 357.231 422.714 357.231C416.676 357.231 411.813 352.515 411.813 346.74C411.813 340.961 416.676 336.249 422.714 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M454.285 336.249C460.322 336.249 465.186 340.963 465.186 346.74C465.186 352.515 460.322 357.231 454.285 357.231C448.247 357.231 443.384 352.515 443.384 346.74C443.384 340.961 448.247 336.249 454.285 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 336.249C491.893 336.249 496.758 340.963 496.758 346.74C496.758 352.515 491.893 357.231 485.857 357.231C479.819 357.231 474.956 352.515 474.956 346.74C474.956 340.961 479.819 336.249 485.857 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M517.429 336.249C523.465 336.249 528.33 340.963 528.33 346.74C528.33 352.515 523.465 357.231 517.429 357.231C511.391 357.231 506.528 352.515 506.528 346.74C506.528 340.961 511.391 336.249 517.429 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 336.249C555.038 336.249 559.903 340.963 559.903 346.74C559.903 352.515 555.038 357.231 549.002 357.231C542.964 357.231 538.101 352.515 538.101 346.74C538.101 340.961 542.964 336.249 549.002 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 336.249C586.61 336.249 591.475 340.963 591.475 346.74C591.475 352.515 586.61 357.231 580.574 357.231C574.536 357.231 569.673 352.515 569.673 346.74C569.673 340.961 574.534 336.249 580.574 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 336.249C619.06 336.249 623.923 340.963 623.923 346.74C623.923 352.515 619.06 357.231 613.022 357.231C606.986 357.231 602.121 352.515 602.121 346.74C602.121 340.961 606.984 336.249 613.022 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 336.249C650.632 336.249 655.495 340.963 655.495 346.74C655.495 352.515 650.632 357.231 644.594 357.231C638.558 357.231 633.693 352.515 633.693 346.74C633.693 340.961 638.557 336.249 644.594 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M676.167 336.249C682.204 336.249 687.068 340.963 687.068 346.74C687.068 352.515 682.204 357.231 676.167 357.231C670.129 357.231 665.266 352.515 665.266 346.74C665.266 340.961 670.127 336.249 676.167 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M707.737 336.249C713.775 336.249 718.638 340.963 718.638 346.74C718.638 352.515 713.775 357.231 707.737 357.231C701.7 357.231 696.836 352.515 696.836 346.74C696.836 340.961 701.699 336.249 707.737 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M739.31 336.249C745.348 336.249 750.211 340.963 750.211 346.74C750.211 352.515 745.347 357.231 739.31 357.231C733.272 357.231 728.409 352.515 728.409 346.74C728.409 340.961 733.272 336.249 739.31 336.249Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M200.832 366.684C206.87 366.684 211.733 371.398 211.733 377.175C211.733 382.95 206.87 387.666 200.832 387.666C194.794 387.666 189.931 382.95 189.931 377.175C189.931 371.398 194.796 366.684 200.832 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M232.404 366.684C238.442 366.684 243.305 371.398 243.305 377.175C243.305 382.95 238.442 387.666 232.404 387.666C226.366 387.666 221.503 382.95 221.503 377.175C221.503 371.398 226.366 366.684 232.404 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M263.977 366.684C270.014 366.684 274.878 371.398 274.878 377.175C274.878 382.95 270.014 387.666 263.977 387.666C257.939 387.666 253.076 382.95 253.076 377.175C253.076 371.398 257.939 366.684 263.977 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M296.427 366.684C302.465 366.684 307.328 371.398 307.328 377.175C307.328 382.95 302.464 387.666 296.427 387.666C290.389 387.666 285.526 382.95 285.526 377.175C285.526 371.398 290.387 366.684 296.427 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 366.684C334.035 366.684 338.898 371.398 338.898 377.175C338.898 382.95 334.035 387.666 327.997 387.666C321.959 387.666 317.096 382.95 317.096 377.175C317.096 371.398 321.959 366.684 327.997 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 366.684C365.607 366.684 370.47 371.398 370.47 377.175C370.47 382.95 365.607 387.666 359.569 387.666C353.532 387.666 348.668 382.95 348.668 377.175C348.668 371.398 353.532 366.684 359.569 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.142 366.684C397.179 366.684 402.043 371.398 402.043 377.175C402.043 382.95 397.179 387.666 391.142 387.666C385.104 387.666 380.24 382.95 380.24 377.175C380.24 371.398 385.104 366.684 391.142 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 366.684C428.752 366.684 433.615 371.398 433.615 377.175C433.615 382.95 428.752 387.666 422.714 387.666C416.676 387.666 411.813 382.95 411.813 377.175C411.813 371.398 416.676 366.684 422.714 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 366.684C460.322 366.684 465.186 371.398 465.186 377.175C465.186 382.95 460.322 387.666 454.285 387.666C448.247 387.666 443.384 382.95 443.384 377.175C443.384 371.398 448.247 366.684 454.285 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 366.684C491.893 366.684 496.758 371.398 496.758 377.175C496.758 382.95 491.893 387.666 485.857 387.666C479.819 387.666 474.956 382.95 474.956 377.175C474.956 371.398 479.819 366.684 485.857 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M517.429 366.684C523.465 366.684 528.33 371.398 528.33 377.175C528.33 382.95 523.465 387.666 517.429 387.666C511.391 387.666 506.528 382.95 506.528 377.175C506.528 371.398 511.391 366.684 517.429 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 366.684C555.038 366.684 559.903 371.398 559.903 377.175C559.903 382.95 555.038 387.666 549.002 387.666C542.964 387.666 538.101 382.95 538.101 377.175C538.101 371.398 542.964 366.684 549.002 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 366.684C586.61 366.684 591.475 371.398 591.475 377.175C591.475 382.95 586.61 387.666 580.574 387.666C574.536 387.666 569.673 382.95 569.673 377.175C569.673 371.398 574.534 366.684 580.574 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 366.684C619.06 366.684 623.923 371.398 623.923 377.175C623.923 382.95 619.06 387.666 613.022 387.666C606.986 387.666 602.121 382.95 602.121 377.175C602.121 371.398 606.984 366.684 613.022 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M644.594 366.684C650.632 366.684 655.495 371.398 655.495 377.175C655.495 382.95 650.632 387.666 644.594 387.666C638.558 387.666 633.693 382.95 633.693 377.175C633.693 371.398 638.557 366.684 644.594 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M676.167 366.684C682.204 366.684 687.068 371.398 687.068 377.175C687.068 382.95 682.204 387.666 676.167 387.666C670.129 387.666 665.266 382.95 665.266 377.175C665.266 371.398 670.127 366.684 676.167 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M707.737 366.684C713.775 366.684 718.638 371.398 718.638 377.175C718.638 382.95 713.775 387.666 707.737 387.666C701.7 387.666 696.836 382.95 696.836 377.175C696.836 371.398 701.7 366.684 707.737 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M739.31 366.684C745.348 366.684 750.211 371.398 750.211 377.175C750.211 382.95 745.347 387.666 739.31 387.666C733.272 387.666 728.409 382.95 728.409 377.175C728.409 371.398 733.272 366.684 739.31 366.684Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M327.997 397.121C334.035 397.121 338.898 401.835 338.898 407.612C338.898 413.387 334.035 418.103 327.997 418.103C321.959 418.103 317.096 413.387 317.096 407.612C317.096 401.835 321.959 397.121 327.997 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M359.569 397.121C365.607 397.121 370.47 401.835 370.47 407.612C370.47 413.387 365.607 418.103 359.569 418.103C353.532 418.103 348.668 413.387 348.668 407.612C348.668 401.835 353.532 397.121 359.569 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 397.121C428.752 397.121 433.615 401.835 433.615 407.612C433.615 413.387 428.752 418.103 422.714 418.103C416.676 418.103 411.813 413.387 411.813 407.612C411.813 401.835 416.676 397.121 422.714 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.285 397.121C460.322 397.121 465.186 401.835 465.186 407.612C465.186 413.387 460.322 418.103 454.285 418.103C448.247 418.103 443.384 413.387 443.384 407.612C443.384 401.835 448.247 397.121 454.285 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 397.121C491.893 397.121 496.758 401.835 496.758 407.612C496.758 413.387 491.893 418.103 485.857 418.103C479.819 418.103 474.956 413.387 474.956 407.612C474.956 401.835 479.819 397.121 485.857 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M517.429 397.121C523.465 397.121 528.33 401.835 528.33 407.612C528.33 413.387 523.465 418.103 517.429 418.103C511.391 418.103 506.528 413.387 506.528 407.612C506.528 401.835 511.391 397.121 517.429 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M549.002 397.121C555.038 397.121 559.903 401.835 559.903 407.612C559.903 413.387 555.038 418.103 549.002 418.103C542.964 418.103 538.101 413.387 538.101 407.612C538.101 401.835 542.964 397.121 549.002 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 397.121C586.61 397.121 591.475 401.835 591.475 407.612C591.475 413.387 586.61 418.103 580.574 418.103C574.536 418.103 569.673 413.387 569.673 407.612C569.673 401.835 574.534 397.121 580.574 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M613.022 397.121C619.06 397.121 623.923 401.835 623.923 407.612C623.923 413.387 619.06 418.103 613.022 418.103C606.986 418.103 602.121 413.387 602.121 407.612C602.121 401.835 606.984 397.121 613.022 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M676.167 397.121C682.204 397.121 687.068 401.835 687.068 407.612C687.068 413.387 682.204 418.103 676.167 418.103C670.129 418.103 665.266 413.387 665.266 407.612C665.266 401.835 670.127 397.121 676.167 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M707.737 397.121C713.775 397.121 718.638 401.835 718.638 407.612C718.638 413.387 713.775 418.103 707.737 418.103C701.7 418.103 696.836 413.387 696.836 407.612C696.836 401.835 701.7 397.121 707.737 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M739.31 397.121C745.348 397.121 750.211 401.835 750.211 407.612C750.211 413.387 745.347 418.103 739.31 418.103C733.272 418.103 728.409 413.387 728.409 407.612C728.409 401.835 733.272 397.121 739.31 397.121Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M391.141 428.402C397.179 428.402 402.043 433.118 402.043 438.893C402.043 444.67 397.179 449.384 391.141 449.384C385.104 449.384 380.24 444.67 380.24 438.893C380.24 433.118 385.104 428.402 391.141 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 428.402C428.752 428.402 433.615 433.118 433.615 438.893C433.615 444.67 428.752 449.384 422.714 449.384C416.676 449.384 411.813 444.67 411.813 438.893C411.813 433.118 416.676 428.402 422.714 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.284 428.402C460.322 428.402 465.185 433.118 465.185 438.893C465.185 444.67 460.322 449.384 454.284 449.384C448.247 449.384 443.383 444.67 443.383 438.893C443.383 433.118 448.247 428.402 454.284 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M485.857 428.402C491.893 428.402 496.758 433.118 496.758 438.893C496.758 444.67 491.893 449.384 485.857 449.384C479.819 449.384 474.956 444.67 474.956 438.893C474.956 433.118 479.819 428.402 485.857 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M580.574 428.402C586.61 428.402 591.475 433.118 591.475 438.893C591.475 444.67 586.61 449.384 580.574 449.384C574.536 449.384 569.673 444.67 569.673 438.893C569.673 433.118 574.534 428.402 580.574 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.2"
      d="M739.31 428.402C745.347 428.402 750.211 433.118 750.211 438.893C750.211 444.67 745.347 449.384 739.31 449.384C733.272 449.384 728.409 444.67 728.409 438.893C728.409 433.118 733.272 428.402 739.31 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 428.402C776.92 428.402 781.784 433.118 781.784 438.893C781.784 444.67 776.92 449.384 770.882 449.384C764.845 449.384 759.981 444.67 759.981 438.893C759.981 433.118 764.845 428.402 770.882 428.402Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M422.714 458.839C428.752 458.839 433.615 463.555 433.615 469.331C433.615 475.107 428.752 479.822 422.714 479.822C416.676 479.822 411.813 475.107 411.813 469.331C411.813 463.555 416.676 458.839 422.714 458.839Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.284 458.839C460.322 458.839 465.185 463.555 465.185 469.331C465.185 475.107 460.322 479.822 454.284 479.822C448.247 479.822 443.383 475.107 443.383 469.331C443.383 463.555 448.247 458.839 454.284 458.839Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M770.882 458.839C776.92 458.839 781.784 463.555 781.784 469.331C781.784 475.107 776.92 479.822 770.882 479.822C764.845 479.822 759.981 475.107 759.981 469.331C759.981 463.555 764.845 458.839 770.882 458.839Z"
      stroke="#54DD8B"
    />
    <path
      opacity="0.1"
      d="M454.284 489.277C460.322 489.277 465.185 493.992 465.185 499.768C465.185 505.544 460.322 510.258 454.284 510.258C448.247 510.258 443.383 505.544 443.383 499.768C443.383 493.992 448.247 489.277 454.284 489.277Z"
      stroke="#54DD8B"
    />
    <path
      d="M523.008 78.084C522.993 78.069 522.104 76.2366 523.164 74.8179C524.254 73.3995 523.308 71.8637 522.635 71.2206C522.796 70.791 522.897 70.3611 522.983 69.9458C523.657 70.678 525.11 72.5736 525.114 75.4694C525.114 75.5585 525.16 75.6331 525.219 75.6929C525.279 75.7526 525.354 75.7977 525.443 75.7983C525.621 75.7995 525.754 75.6667 525.753 75.4884C525.742 71.7015 523.515 69.5335 523.112 69.1596C523.196 68.3285 523.146 67.5411 522.919 66.8713C523.052 66.798 523.185 66.6949 523.303 66.5769C523.436 66.4441 523.539 66.3111 523.612 66.1482L525.764 68.3009C525.884 68.4205 526.092 68.4219 526.21 68.3039L526.771 67.7433C527.051 67.463 527.526 67.4661 527.81 67.7502C527.93 67.8698 528.138 67.8711 528.256 67.7531C528.374 67.6351 528.372 67.4272 528.253 67.3076C527.715 66.7694 526.853 66.7637 526.322 67.2948L525.983 67.6341L523.785 65.4366C523.784 65.3178 523.784 65.199 523.753 65.08L524.963 63.8702C525.081 63.7522 525.08 63.5443 524.96 63.4247C524.84 63.3051 524.632 63.3037 524.514 63.4217L523.496 64.4397C523.437 64.3502 523.362 64.2754 523.287 64.2007C523.212 64.126 523.123 64.066 523.048 63.9912L524.066 62.9733C524.184 62.8552 524.183 62.6473 524.063 62.5277C523.943 62.4081 523.736 62.4068 523.617 62.5248L522.408 63.7345C522.289 63.704 522.17 63.7033 522.051 63.7025L519.854 61.505L520.193 61.1656C520.724 60.6345 520.718 59.7732 520.18 59.235C520.061 59.1154 519.853 59.114 519.735 59.2321C519.617 59.3501 519.618 59.558 519.738 59.6776C520.022 59.9616 520.025 60.4369 519.744 60.7172L519.184 61.2778C519.066 61.3958 519.067 61.6037 519.187 61.7233L521.339 63.876C521.177 63.9492 521.044 64.0522 520.911 64.185C520.793 64.303 520.69 64.436 520.616 64.5692C519.932 64.3567 519.144 64.2773 518.328 64.3758C517.954 63.9724 515.786 61.7454 512.044 61.7206C511.866 61.7194 511.733 61.8522 511.734 62.0304C511.735 62.1195 511.78 62.1941 511.839 62.2539C511.899 62.3137 511.974 62.3587 512.063 62.3593C514.944 62.3784 516.854 63.8166 517.586 64.4897C517.171 64.5761 516.726 64.692 516.312 64.8377C515.669 64.1652 514.118 63.2342 512.714 64.309C511.266 65.3984 509.419 64.4951 509.404 64.4802C509.24 64.4048 509.062 64.4631 508.989 64.6259C508.93 64.7443 508.961 64.8931 509.051 64.9828C509.081 65.0126 509.096 65.0276 509.14 65.0427C509.23 65.1027 511.345 66.1266 513.074 64.8163C514.108 64.0212 515.182 64.7114 515.645 65.0858C515.438 65.1735 515.23 65.2612 515.038 65.3639C514.801 65.4217 513.199 65.7973 511.424 66.7953C508.909 68.234 507.288 70.2133 506.74 72.556C506.711 72.6746 506.756 72.7789 506.831 72.8536C506.876 72.8984 506.92 72.9136 506.98 72.9437C507.143 72.9893 507.321 72.8717 507.364 72.7086C508.101 69.5207 510.777 67.7414 512.805 66.8193C512.569 67.0256 512.318 67.2467 512.097 67.468C509.633 69.9318 509.739 72.4273 512.399 75.0883C515.06 77.7492 517.556 77.8549 520.02 75.3911C520.241 75.1698 520.462 74.9189 520.668 74.6826C519.746 76.711 517.967 79.3872 514.779 80.1235C514.616 80.1669 514.513 80.3296 514.544 80.508C514.544 80.5674 514.589 80.6123 514.634 80.6571C514.709 80.7319 514.828 80.7623 514.932 80.7482C517.274 80.1994 519.254 78.5789 520.663 76.0934C521.661 74.3179 522.051 72.7018 522.094 72.4794C522.197 72.287 522.285 72.0796 522.372 71.8723C522.747 72.3352 523.452 73.3942 522.642 74.4432C521.332 76.1721 522.355 78.2876 522.415 78.3771C522.431 78.4218 522.446 78.4367 522.476 78.4666C522.565 78.5563 522.714 78.587 522.832 78.5283C523.025 78.4257 523.083 78.2478 523.008 78.084ZM522.854 66.1284C522.441 66.5415 521.788 66.5372 521.369 66.1186C520.951 65.7 520.946 65.0466 521.359 64.6335C521.772 64.2204 522.426 64.2247 522.844 64.6433C523.263 65.0619 523.267 65.7153 522.854 66.1284ZM512.842 74.6457C510.405 72.209 510.317 70.1442 512.545 67.9165C514.802 65.6594 518.269 64.4646 520.442 65.162C520.386 65.6666 520.538 66.1725 520.927 66.5612C521.3 66.9349 521.821 67.1017 522.326 67.0456C523.023 69.2184 521.828 72.6855 519.571 74.9427C517.344 77.1704 515.279 77.0824 512.842 74.6457Z"
      fill="#54DD8B"
    />
  </svg>
)
